















import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import SearchGeneralAgent from '@/mixins/search-queries/search-ga'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import { IPolicyCarrierInput } from '@/modules/Policy/interfaces/policy-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class PolicyFormCarrier extends mixins(SearchGeneralAgent, SearchCarrier) {
  @Prop({ type: Object as () => IPolicyCarrierInput }) value!: IPolicyCarrierInput

  validate () {
    return (this.$refs.form1 as Vue & { validate: () => boolean }).validate()
  }
}
